<template>
  <div >
    <Snackbar></Snackbar>
    <div>
       <v-alert transition="scale-transition"
                 origin="center center"
                 v-show="alert"
                 dense
                 :color="alertColor"
                 outlined
                 type="error"
                 :timeout="timeout">
            {{error}}
        </v-alert>
        <v-text-field v-model="userName"
                      placeholder="UserName"
                      label="UserName"
                      outlined
                      dense
                      ></v-text-field>
        <v-text-field v-model="email"
                      placeholder="Email"
                      label="Email"
                      outlined
                      dense
                      ></v-text-field>
      <div class="d-flex justify-end">
        <v-btn class="mx-2" small color="success"
               @click="$emit('back')">
          Back
        </v-btn>
        <v-btn small color="primary"
               @click="sendEmail">
          Send
        </v-btn>
      </div>
    </div>
  </div>
</template>

<script>
    import { validationMixin } from 'vuelidate'
    import { required, sameAs } from "vuelidate/lib/validators";
    import axios from "axios";
  export default {
      layout: 'public',
      auth: 'guest',
      mixins: [validationMixin],
      validations: {
      password: { required },
      confirmPassword: {  required,sameAsPassword: sameAs("password") }
    },

    data() {
        return {
        alert: false,
        alertColor: '',
        timeout: 100,
        error: '',
        resetCode: null,
        resetConfirm: false,
        passwordChanged: false,
        password: '',
        confirmPassword: '',
        userName: '',
         e1: 1
      }
    },
        methods: {

            async sendEmail() {
                console.log('username', this.userName)
                console.log('email', this.email)
                this.requestPasswordLoading = true
                axios.get('User/RequestResetPassword/' + this.email + ' /' + this.userName).then(response => {
                    console.log(response.data.errors)
                    this.requestPasswordLoading = false
                    if (response.data.success) {
                        this.alert = true
                        this.alertColor = 'success'
                        this.error = "Please Check the email for Code"
                    } else {
                        this.alert = true
                        this.alertColor = 'error'
                        this.error = response.data.errors[0]
                    }

                }).catch(err => {
                    this.alert = true
                    this.alertColor = 'error'
                    this.error = err
                })
            },

    }
  }
</script>

<style scoped lang="scss">
    .inputBox {
        width: 70%
    }
    .homePageLink {
        text-decoration: none;
        color: white;
        font-style: italic;

        &:hover {
            text-decoration: underline;
        }
    }
</style>
